export const imageToBytes = (cropImageArea: HTMLImageElement) => {
    const canvas = document.createElement("canvas");

    canvas.width = cropImageArea.naturalWidth;
    canvas.height = cropImageArea.naturalHeight;

    const ctx = canvas.getContext("2d");
    if (ctx === null)
        return null;

    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(
        cropImageArea,
        0,
        0
    );

    return canvas.toDataURL("image/png", 1);
}
